export interface NewsItem {
  id: string;
  title: string;
  category: string;
  date: string;
  views: number;
  cover: string;
  summary: string;
  author: string;
  tags: string[];
  content: string[];
}

export const newsCategories = ["最新动态", "活动公告", "行业观点", "媒体访谈"];

export const newsList: NewsItem[] = [
  {
    id: "n001",
    title: "张津瑜受邀出席2026年度品牌影响力峰会并发表主题演讲",
    category: "最新动态",
    date: "2026-09-28",
    views: 18640,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20business%20summit%20main%20stage%20with%20large%20LED%20screen%20and%20warm%20spotlights%2C%20audience%20silhouettes%2C%20deep%20navy%20and%20orange%20stage%20lighting%2C%20clean%20minimal%20conference%20hall%2C%20editorial%20photography%20wide%20composition&width=1280&height=720&seq=news-cover-01&orientation=landscape",
    summary:
      "在以“长期主义的品牌力量”为主题的年度峰会上，张津瑜与来自不同领域的嘉宾共同探讨个人品牌如何穿越周期、持续生长。",
    author: "品牌传播中心",
    tags: ["峰会", "个人品牌", "长期主义"],
    content: [
      "9月28日，2026年度品牌影响力峰会在北京举行。作为受邀演讲嘉宾，张津瑜以《个人品牌的下一个十年》为题，分享了自己从内容创作到品牌运营的完整思考路径。",
      "在演讲中，张津瑜提出：“个人品牌不是一次曝光，而是一段可以被反复验证的信任关系。”她结合过去五年的实践，拆解了内容、作品与公众沟通三者之间的关系，并强调稳定的价值观输出才是长期主义的根基。",
      "圆桌环节，张津瑜与多位行业观察者就“创作者如何平衡商业与表达”展开讨论。她认为，真诚的表达本身就是最好的商业资产，任何以牺牲信任为代价的短期收益都不值得。",
      "峰会期间，张津瑜还公布了接下来一年在内容共创与公益影像方向的计划，现场反响热烈。完整演讲内容将在官网资讯中心陆续发布。",
    ],
  },
  {
    id: "n002",
    title: "全新个人官方主视觉正式发布：一次关于“光”的表达",
    category: "最新动态",
    date: "2026-09-15",
    views: 15230,
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20studio%20backdrop%20with%20soft%20light%20beams%20and%20warm%20orange%20glow%20against%20deep%20navy%20gradient%2C%20minimal%20geometric%20shapes%2C%20premium%20brand%20key%20visual%2C%20clean%20editorial%20aesthetic%20high%20detail&width=1280&height=720&seq=news-cover-02&orientation=landscape",
    summary:
      "历经三个月打磨，张津瑜个人品牌全新主视觉正式上线。这一次，团队选择用光与影讲述“不断向前”的品牌故事。",
    author: "视觉团队",
    tags: ["主视觉", "品牌升级"],
    content: [
      "9月15日，张津瑜个人品牌全新官方主视觉正式发布。本次视觉以“光”为核心意象，通过明暗对比与流动的光线，传递出在不确定中依然保持前行的力量感。",
      "据视觉团队介绍，主视觉历时三个月，从上百版草图中最终确定了以深蓝为底、暖光为笔的方案。深蓝象征沉稳与专业，暖光则代表亲和与温度，两者共同构成了张津瑜个人品牌的完整气质。",
      "新主视觉将全面应用于官方网站、资讯配图、作品封面及线下活动物料。同步更新的还有品牌标准字与辅助图形系统，为后续的内容扩展打下统一基础。",
      "品牌方表示，视觉的更新不是为了颠覆，而是为了让更多人一眼读懂张津瑜想传递的价值：在喧嚣中保持清醒，在专业中保留温度。",
    ],
  },
  {
    id: "n003",
    title: "张津瑜携手公益机构启动“微光计划”，首站落地西部山区",
    category: "活动公告",
    date: "2026-08-30",
    views: 13980,
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20documentary%20scene%20of%20children%20reading%20books%20in%20a%20sunlit%20mountain%20village%20classroom%2C%20soft%20golden%20light%2C%20hopeful%20atmosphere%2C%20muted%20earth%20tones%20with%20navy%20accents%2C%20editorial%20photography&width=1280&height=720&seq=news-cover-03&orientation=landscape",
    summary:
      "“微光计划”聚焦乡村儿童的美育与影像教育，张津瑜将全程参与课程设计与志愿授课，并推出同名公益影像作品。",
    author: "公益项目组",
    tags: ["公益", "微光计划", "美育"],
    content: [
      "8月30日，张津瑜个人品牌联合公益机构正式启动“微光计划”。该计划以乡村儿童的美育与影像教育为切入点，希望通过持续的课程与陪伴，让更多孩子拥有表达自我的机会。",
      "首站选择落地西部山区的一所乡村小学。张津瑜与志愿团队为孩子们带去了影像器材与课程，并一起完成了第一支由孩子们自己拍摄的短片。",
      "“微光不是要照亮所有人，而是让每个人发现自己也能发光。”张津瑜在活动现场这样形容计划的名字。她表示，自己会以志愿者而非“明星”的身份长期参与其中。",
      "“微光计划”后续将逐步扩展至更多地区，相关进展与影像作品将持续在官网资讯中心更新。",
    ],
  },
  {
    id: "n004",
    title: "深度访谈：从台前到幕后，一次关于内容创作的坦白",
    category: "媒体访谈",
    date: "2026-08-12",
    views: 12760,
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20scene%20of%20a%20podcast%20interview%20studio%20with%20two%20microphones%2C%20warm%20ambient%20lighting%2C%20deep%20navy%20acoustic%20wall%20panels%2C%20soft%20orange%20rim%20light%2C%20minimal%20premium%20interior&width=1280&height=720&seq=news-cover-04&orientation=landscape",
    summary:
      "在一个安静的午后，张津瑜聊了聊创作焦虑、被误解的时刻，以及她如何重新定义“被看见”的意义。",
    author: "《在场》栏目",
    tags: ["访谈", "创作", "幕后"],
    content: [
      "这是张津瑜今年为数不多的长篇深度访谈。没有舞台，没有脚本，只有一支录音笔和一下午的时间。",
      "谈到创作焦虑，她坦言曾经有过很长一段时间不敢打开评论区。“后来我想明白了一件事：你无法控制别人如何理解你，但你可以控制自己是否足够真诚。”",
      "被问到如何看待“被误解”，张津瑜笑着说，误解几乎是表达的一部分。“如果我说的每句话都被所有人认同，那说明我可能什么重要的话都没说。”",
      "访谈最后，她给年轻的创作者留下了一句建议：“先成为一个完整的人，再成为一个创作者。作品会诚实地反映你是谁。”",
    ],
  },
  {
    id: "n005",
    title: "张津瑜2026全国巡回分享会正式官宣，首轮五城开票",
    category: "活动公告",
    date: "2026-07-25",
    views: 21430,
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20theater%20auditorium%20with%20rows%20of%20warm%20seats%20and%20soft%20stage%20lighting%2C%20empty%20stage%20ready%20for%20a%20talk%20show%2C%20deep%20navy%20curtain%20and%20orange%20accent%20light%2C%20minimal%20editorial%20photography&width=1280&height=720&seq=news-cover-05&orientation=landscape",
    summary:
      "以“与你同行”为主题的全国巡回分享会正式公布，张津瑜将走进五座城市，与观众面对面聊聊创作与生活。",
    author: "活动运营组",
    tags: ["巡回", "分享会", "线下"],
    content: [
      "7月25日，张津瑜2026全国巡回分享会正式官宣。本次巡回以“与你同行”为主题，首轮将在五座城市举办，每场设置主题分享与观众问答环节。",
      "与以往不同，本次分享会大幅增加了互动比例。张津瑜表示，她不想做单向的“演讲”，而更希望是一场真诚的对话。“我想听听大家的问题，也想把一些还没成形的想法拿出来一起讨论。”",
      "首轮城市与场次安排已公布，门票于官宣当日同步开售。更多城市正在陆续规划中，敬请关注官网后续公告。",
    ],
  },
  {
    id: "n006",
    title: "品牌成立五周年：回望来路，也写给未来",
    category: "最新动态",
    date: "2026-06-18",
    views: 16890,
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20five%20minimal%20photo%20prints%20and%20a%20notebook%20on%20a%20soft%20gray%20desk%2C%20warm%20natural%20window%20light%2C%20deep%20navy%20and%20orange%20stationery%20accents%2C%20calm%20editorial%20composition&width=1280&height=720&seq=news-cover-06&orientation=landscape",
    summary:
      "五年前的今天，张津瑜发布了第一条内容。五年后，她想用一封信，和一直陪伴的人聊聊这一路的变化。",
    author: "张津瑜",
    tags: ["五周年", "品牌", "手记"],
    content: [
      "五年，说长不长，说短也不短。今天，我想把它当成一个节点，认认真真地回望一次。",
      "五年前的今天，我发布了第一条内容。那时候没有团队，没有计划，只有一个笨拙但真实的念头：我想把我看到的世界讲给别人听。",
      "这五年，我学会了把“表达欲”变成“责任感”。当我意识到有越来越多的人在认真听我说话时，我就不能再随便说话了。这不是压力，而是一种被信任的幸运。",
      "未来我想做的事情其实很简单：继续做真诚的内容，继续走在路上，也继续和大家保持连接。谢谢你们，愿意陪我走这一段。",
    ],
  },
  {
    id: "n007",
    title: "张津瑜入选年度杰出青年代表，用作品回应时代",
    category: "最新动态",
    date: "2026-05-20",
    views: 19250,
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20award%20ceremony%20backdrop%20with%20soft%20golden%20light%20and%20elegant%20deep%20navy%20drape%2C%20abstract%20trophy%20shape%20in%20warm%20orange%20tone%2C%20premium%20event%20visual%2C%20clean%20editorial%20photography&width=1280&height=720&seq=news-cover-07&orientation=landscape",
    summary:
      "凭借在内容创作与公益影像方向的持续投入，张津瑜入选本年度杰出青年代表，并在颁奖现场分享了自己的作品理念。",
    author: "品牌传播中心",
    tags: ["荣誉", "青年代表"],
    content: [
      "5月20日，年度杰出青年代表名单公布，张津瑜因在内容创作与公益影像领域的持续投入而入选。",
      "在颁奖现场，张津瑜把这份荣誉归功于团队和观众：“不是我一个人做成了什么，而是一群愿意相信同一件事的人，把它一起做成了。”",
      "她同时分享了自己对“用作品回应时代”的理解：好的作品不一定要宏大地讲述，有时候只需要诚实地记录一个具体的瞬间、一个真实的人。",
      "据了解，张津瑜接下来将继续推进公益影像项目，并计划推出个人首部纪录长片。",
    ],
  },
  {
    id: "n008",
    title: "幕后花絮：一次广告片拍摄的48小时",
    category: "行业观点",
    date: "2026-04-14",
    views: 11340,
    cover:
      "https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20camera%20rig%2C%20lighting%20stands%20and%20softboxes%2C%20crew%20silhouettes%2C%20warm%20orange%20key%20light%20against%20deep%20navy%20background%2C%20cinematic%20editorial%20photography&width=1280&height=720&seq=news-cover-08&orientation=landscape",
    summary:
      "从凌晨四点的妆发到深夜的收工，我们把48小时里最真实的片段记录下来，聊聊一支片子背后的判断与取舍。",
    author: "制作团队",
    tags: ["幕后", "拍摄", "行业"],
    content: [
      "很多人看到的是成片里光鲜的几十秒，但一支广告片的背后，是几十个人连续48小时的判断与协作。",
      "这次拍摄最大的挑战来自天气。原定的外景日程被一场大雨打乱，团队在两个小时里重新调整了全部分镜与灯光方案。",
      "张津瑜在片场说得最多的一句话是“再来一条”。她坚持在有限的预算里保留属于自己的表达，哪怕这意味着更多的时间成本。",
      "我们把这次的幕后花絮整理成文，希望让更多对影像感兴趣的年轻人看到：所谓专业，不过是一次次不肯将就的累积。",
    ],
  },
  {
    id: "n009",
    title: "关于个人品牌内容规范与版权声明",
    category: "行业观点",
    date: "2026-03-02",
    views: 8760,
    cover:
      "https://readdy.ai/api/search-image?query=Clean%20minimal%20document%20and%20signature%20concept%20flat%20lay%20on%20soft%20gray%20surface%2C%20deep%20navy%20and%20warm%20orange%20paper%20accents%2C%20elegant%20editorial%20studio%20lighting%2C%20professional%20look&width=1280&height=720&seq=news-cover-09&orientation=landscape",
    summary:
      "为规范内容使用、保护原创权益，张津瑜个人品牌就内容转载、合作授权与版权归属发布统一说明。",
    author: "品牌传播中心",
    tags: ["声明", "版权", "规范"],
    content: [
      "为规范内容使用、保护原创权益，张津瑜个人品牌现就相关内容使用规范作如下说明。",
      "一、官方网站资讯中心发布的所有文字、图片、视频内容，除特别标注外，版权均归张津瑜个人品牌所有。任何机构或个人如需转载，请事先获得书面授权。",
      "二、在获得授权的前提下，转载须完整保留作者署名与来源信息，不得对内容进行断章取义或误导性修改。",
      "三、如需进行商业合作或内容授权，可通过官网“联系我们”页面提交申请，我们将在三个工作日内回复。对于未经授权的侵权行为，品牌方将依法追究相关责任。",
    ],
  },
];

export const getNewsById = (id: string): NewsItem | undefined =>
  newsList.find((item) => item.id === id);

export const getRelatedNews = (item: NewsItem, limit = 3): NewsItem[] => {
  const sameCategory = newsList.filter(
    (n) => n.id !== item.id && n.category === item.category,
  );
  const others = newsList.filter(
    (n) => n.id !== item.id && n.category !== item.category,
  );
  return [...sameCategory, ...others].slice(0, limit);
};